import { render, staticRenderFns } from "./FileDocumentPlusOutline.vue?vue&type=template&id=1f0631fe"
import script from "./FileDocumentPlusOutline.vue?vue&type=script&lang=js"
export * from "./FileDocumentPlusOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports